/* @flow strict */

import { RoutesType } from 'client/src/routes';
import Integrations from './index';
import IntegrationsFB from './fb/';
import IntegrationsMailchimp from './mailchimp';
import IntegrationsCalendar from './calendar/';
import IntegrationsCards from './cards';
import IntegrationsWidget from './widget';

export const IntegrationsRoutes: RoutesType = [
  {
    Component: IntegrationsFB,
    params: {
      path: '/integrations/facebook-app/:viewTab?'
    }
  },
  {
    Component: IntegrationsMailchimp,
    params: {
      path: '/integrations/mailchimp/:viewTab?'
    }
  },
  {
    Component: IntegrationsCalendar,
    params: {
      path: '/integrations/calendar'
    }
  },
  {
    Component: IntegrationsCards,
    params: {
      path: '/integrations/cards/:viewTab?'
    }
  },
  {
    Component: IntegrationsWidget,
    params: {
      path: '/integrations/widget/:viewTab?'
    }
  },
  {
    Component: Integrations,
    params: {
      exact: true,
      path: '/integrations'
    }
  }
];
